import React from "react";
import { navigate } from "gatsby";
import { Commitment, Deal } from "@ifgengineering/client-invest-sdk";
import { PortfolioInvestmentCardsContainer } from "../../portfolio/v2/PortfolioDashboard/PortfolioInvestmentsSection";
import { PortfolioInvestmentCard } from "../../portfolio/v2/PortfolioInvestmentCard";
import { SectionContainer } from "./styled";
import { ItemsCount } from "./IfIsaDealsSection";

interface IfIsaInvestmentsSectionProps {
  commitments: Commitment[];
  deals: Deal[];
}

export const IfIsaInvestmentsSection = ({
  commitments,
  deals,
}: IfIsaInvestmentsSectionProps) => {
  const ifIsaCommitments = commitments.filter(
    (commitment) => commitment?.ifIsaAccountId !== null
  );
  return (
    <SectionContainer>
      <ItemsCount label="IF-ISA Investments" count={ifIsaCommitments.length} />
      <PortfolioInvestmentCardsContainer>
        {ifIsaCommitments.map((commitment, index) => {
          const deal = deals.find((deal) => deal.id === commitment.dealId);
          const onCardClick = () => {
            navigate(
              `/app/portfolio/investment/${commitment.id}?referrer=ifisa&dealId=${commitment.dealId}`
            );
          };
          return (
            <PortfolioInvestmentCard
              key={commitment.id}
              commitment={commitment}
              deal={deal}
              onClick={onCardClick}
            />
          );
        })}
      </PortfolioInvestmentCardsContainer>
    </SectionContainer>
  );
};
